import { FetchBaseQueryError } from '@reduxjs/toolkit/query'

export const getDebugErrorMessage = (error: unknown): string => {
  if (error && typeof error === 'object' && 'data' in error) {
    const data = (error as FetchBaseQueryError).data
    if (
      data &&
      typeof data === 'object' &&
      'message' in data &&
      typeof data.message === 'string' &&
      data.message
    ) {
      return data.message
    }
  }

  return "Impossible de charger les données de debug. L'endpoint n'est peut-être pas encore disponible."
}

export const displayValue = (value: string | number | null | undefined) => {
  if (value === null || value === undefined || value === '') {
    return '-'
  }
  return String(value)
}
